import type { ReactNode } from "react";
import { cx } from "@/shared/lib/cx";
import { Icon, type IconName } from "../Icon";

export interface TabOption<T extends string> { value: T; label: ReactNode; icon?: IconName; count?: number }

/** Segmented control (filters) or underlined tabs (page sections). */
export function Tabs<T extends string>({ value, options, onChange, label, variant = "segmented" }: {
  value: T; options: TabOption<T>[]; onChange: (v: T) => void; label: string; variant?: "segmented" | "underline";
}) {
  return (
    <div className={cx("tabs", variant === "underline" && "tabs-underline")} role="tablist" aria-label={label}>
      {options.map((o) => (
        <button
          key={o.value} type="button" role="tab" aria-selected={value === o.value}
          className={cx("tab", value === o.value && "tab-active")} onClick={() => onChange(o.value)}
        >
          {o.icon && <Icon name={o.icon} size={15} />}
          {o.label}
          {o.count !== undefined && <span className="tab-count">{o.count}</span>}
        </button>
      ))}
    </div>
  );
}
